var _defs, _circle, _circle2, _circle3, _ellipse, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle0, _circle1, _path, _path2, _ellipse2, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7, _polygon8, _polygon9, _polygon0, _polygon1, _polygon10, _polygon11, _path3, _path4, _path5, _path6, _path7, _polygon12, _polygon13, _polygon14, _polygon15, _polygon16, _polygon17, _polygon18, _polygon19, _polygon20, _line, _line2, _line3, _g, _rect, _circle10, _rect2, _circle11, _circle12, _circle13, _path8, _rect3, _rect4, _circle14, _circle15, _path9, _rect5, _rect6, _line4, _rect7, _rect8, _rect9, _rect0, _path0, _line5, _g2, _path1, _g3, _g4, _path10, _path11;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgContractExchange = (_ref, ref) => {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 490,
    height: 392,
    viewBox: "0 0 490 392",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Acculex \u2014 create, collaborate, sign and manage contracts") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "plat",
    x1: 0,
    y1: 0,
    x2: 0.4,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5A82F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B4CC0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "platRim",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#233F8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16265A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "card",
    x1: 0,
    y1: 0,
    x2: 0.5,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1F4FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gold",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FFC658"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB024"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ribbon",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FBB024"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B06A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hdr",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2B4CC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4A79F0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "blobW",
    cx: 0.5,
    cy: 0.5,
    r: 0.5
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FBB024",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB024",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "blobB",
    cx: 0.5,
    cy: 0.5,
    r: 0.5
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3A68DF",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3A68DF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "glow",
    cx: 0.5,
    cy: 0.45,
    r: 0.6
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#E2ECFF",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E2ECFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("filter", {
    id: "soft",
    x: "-40%",
    y: "-40%",
    width: "180%",
    height: "180%"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 8,
    stdDeviation: 10,
    floodColor: "#20305B",
    floodOpacity: 0.16
  })), /*#__PURE__*/React.createElement("filter", {
    id: "soft2",
    x: "-60%",
    y: "-60%",
    width: "220%",
    height: "220%"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 4,
    stdDeviation: 6,
    floodColor: "#20305B",
    floodOpacity: 0.2
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 386,
    cy: 150,
    r: 168,
    fill: "url(#blobW)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 96,
    cy: 238,
    r: 150,
    fill: "url(#blobB)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 404,
    cy: 96,
    r: 70,
    fill: "none",
    stroke: "#FBB024",
    strokeWidth: 9,
    opacity: 0.55
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 245,
    cy: 150,
    rx: 200,
    ry: 170,
    fill: "url(#glow)"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 64,
    cy: 74,
    r: 3,
    fill: "#4A79F0",
    opacity: 0.7
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 92,
    cy: 44,
    r: 4.5,
    fill: "#FBB024",
    opacity: 0.7
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 452,
    cy: 120,
    r: 3,
    fill: "#4BB970",
    opacity: 0.7
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 250,
    r: 3,
    fill: "#8FABF3",
    opacity: 0.7
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 432,
    cy: 300,
    r: 4,
    fill: "#FBB024",
    opacity: 0.7
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 150,
    cy: 28,
    r: 3.5,
    fill: "#F8694A",
    opacity: 0.7
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: 470,
    cy: 210,
    r: 3,
    fill: "#8FABF3",
    opacity: 0.7
  })), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    cx: 58,
    cy: 150,
    r: 6,
    fill: "none",
    stroke: "#F8694A",
    strokeWidth: 2.4,
    opacity: 0.6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 462 60 l 0 12 M 456 66 l 12 0",
    stroke: "#FBB024",
    strokeWidth: 2.6,
    strokeLinecap: "round",
    opacity: 0.7
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 120 120 Q 245 20 372 120",
    fill: "none",
    stroke: "#8FABF3",
    strokeWidth: 2,
    strokeDasharray: "2 8",
    strokeLinecap: "round",
    opacity: 0.6
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 242,
    cy: 330,
    rx: 180,
    ry: 46,
    fill: "#20305B",
    opacity: 0.13
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "420.00,205.60 246.00,292.60 246.00,301.60 420.00,214.60",
    fill: "url(#platRim)"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "72.00,205.60 246.00,292.60 246.00,301.60 72.00,214.60",
    fill: "url(#platRim)"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "246.00,118.60 420.00,205.60 246.00,292.60 72.00,205.60",
    fill: "url(#platRim)"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "402.00,201.40 246.00,279.40 246.00,283.60 402.00,205.60",
    fill: "#2B4CC0"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "90.00,201.40 246.00,279.40 246.00,283.60 90.00,205.60",
    fill: "#1B357A"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "246.00,123.40 402.00,201.40 246.00,279.40 90.00,201.40",
    fill: "url(#plat)"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    points: "246.00,135.10 378.00,201.10 246.00,267.10 114.00,201.10",
    fill: "none",
    stroke: "#6E93F4",
    strokeWidth: 1.2,
    opacity: 0.5
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    points: "154.20,183.10 135.00,192.70 135.00,207.70 154.20,198.10",
    fill: "#C66F09"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    points: "115.80,183.10 135.00,192.70 135.00,207.70 115.80,198.10",
    fill: "#8C4C01"
  })), _polygon0 || (_polygon0 = /*#__PURE__*/React.createElement("polygon", {
    points: "135.00,173.50 154.20,183.10 135.00,192.70 115.80,183.10",
    fill: "#E4E7F2"
  })), _polygon1 || (_polygon1 = /*#__PURE__*/React.createElement("polygon", {
    points: "154.20,183.40 135.00,193.00 135.00,194.80 154.20,185.20",
    fill: "#C67A00"
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    points: "115.80,183.40 135.00,193.00 135.00,194.80 115.80,185.20",
    fill: "#C67A00"
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    points: "135.00,173.80 154.20,183.40 135.00,193.00 115.80,183.40",
    fill: "#FBB024"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    transform: "rotate(-22 135 164.1)",
    d: "M 135 164.1 q 2 -18 0.6 -30",
    fill: "none",
    stroke: "#0A8A54",
    strokeWidth: 7,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    transform: "rotate(-2 135 164.1)",
    d: "M 135 164.1 q 2 -22.8 0.6 -38",
    fill: "none",
    stroke: "#43979B",
    strokeWidth: 7,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    transform: "rotate(16 135 164.1)",
    d: "M 135 164.1 q 2 -19.2 0.6 -32",
    fill: "none",
    stroke: "#4BB970",
    strokeWidth: 7,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    transform: "rotate(34 135 164.1)",
    d: "M 135 164.1 q -2 -15.6 -0.6 -26",
    fill: "none",
    stroke: "#0A8A54",
    strokeWidth: 7,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    transform: "rotate(-40 135 164.1)",
    d: "M 135 164.1 q -2 -14.399999999999999 -0.6 -24",
    fill: "none",
    stroke: "#4BB970",
    strokeWidth: 7,
    strokeLinecap: "round"
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    points: "355.50,221.80 315.00,242.05 315.00,245.35 355.50,225.10",
    fill: "#E4E7F2"
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    points: "280.50,224.80 315.00,242.05 315.00,245.35 280.50,228.10",
    fill: "#CDD3E6"
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    points: "321.00,204.55 355.50,221.80 315.00,242.05 280.50,224.80",
    fill: "url(#card)"
  })), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    points: "358.50,217.60 318.00,237.85 318.00,241.15 358.50,220.90",
    fill: "#E4E7F2"
  })), _polygon16 || (_polygon16 = /*#__PURE__*/React.createElement("polygon", {
    points: "283.50,220.60 318.00,237.85 318.00,241.15 283.50,223.90",
    fill: "#CDD3E6"
  })), _polygon17 || (_polygon17 = /*#__PURE__*/React.createElement("polygon", {
    points: "324.00,200.35 358.50,217.60 318.00,237.85 283.50,220.60",
    fill: "url(#card)"
  })), _polygon18 || (_polygon18 = /*#__PURE__*/React.createElement("polygon", {
    points: "361.50,213.40 321.00,233.65 321.00,236.95 361.50,216.70",
    fill: "#E4E7F2"
  })), _polygon19 || (_polygon19 = /*#__PURE__*/React.createElement("polygon", {
    points: "286.50,216.40 321.00,233.65 321.00,236.95 286.50,219.70",
    fill: "#CDD3E6"
  })), _polygon20 || (_polygon20 = /*#__PURE__*/React.createElement("polygon", {
    points: "327.00,196.15 361.50,213.40 321.00,233.65 286.50,216.40",
    fill: "url(#card)"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 323.55,
    y1: 203.54,
    x2: 344.85,
    y2: 214.19,
    stroke: "#6E93F4",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 314.55,
    y1: 208.04,
    x2: 335.85,
    y2: 218.69,
    stroke: "#D9DEEE",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 305.55,
    y1: 212.54,
    x2: 318.45,
    y2: 219,
    stroke: "#D9DEEE",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#soft)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 185,
    y: 6.400000000000006,
    width: 60,
    height: 26,
    rx: 8,
    fill: "#FBB024"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 158,
    y: 24.400000000000006,
    width: 166,
    height: 198,
    rx: 14,
    fill: "#C9D2EA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 163,
    y: 19.400000000000006,
    width: 166,
    height: 198,
    rx: 14,
    fill: "url(#card)"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 181,
    y: 35.400000000000006,
    width: 130,
    height: 26,
    rx: 7,
    fill: "url(#hdr)"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 197,
    cy: 48.400000000000006,
    r: 7,
    fill: "#FFFFFF",
    opacity: 0.92
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 211,
    y: 44.400000000000006,
    width: 58,
    height: 7,
    rx: 3.5,
    fill: "#FFFFFF",
    opacity: 0.85
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 297,
    cy: 48.400000000000006,
    r: 4.5,
    fill: "#FBB024"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 194,
    cy: 85.4,
    r: 12,
    fill: "#3A68DF"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 194,
    cy: 82.4,
    r: 4.2,
    fill: "#FFFFFF",
    opacity: 0.95
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M 186 93.4 a 8 7 0 0 1 16 0",
    fill: "#FFFFFF",
    opacity: 0.95
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 213,
    y: 79.4,
    width: 86,
    height: 6,
    rx: 3,
    fill: "#C3CADE"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 213,
    y: 88.4,
    width: 58,
    height: 5,
    rx: 2.5,
    fill: "#E0E4F0"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 194,
    cy: 117.4,
    r: 12,
    fill: "#43979B"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 194,
    cy: 114.4,
    r: 4.2,
    fill: "#FFFFFF",
    opacity: 0.95
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M 186 125.4 a 8 7 0 0 1 16 0",
    fill: "#FFFFFF",
    opacity: 0.95
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 213,
    y: 111.4,
    width: 86,
    height: 6,
    rx: 3,
    fill: "#C3CADE"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 213,
    y: 120.4,
    width: 58,
    height: 5,
    rx: 2.5,
    fill: "#E0E4F0"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 181,
    y1: 139.4,
    x2: 311,
    y2: 139.4,
    stroke: "#EAEDF6",
    strokeWidth: 2
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 181,
    y: 151.4,
    width: 130,
    height: 5,
    rx: 2.5,
    fill: "#DDE2F0"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 181,
    y: 164.4,
    width: 116,
    height: 5,
    rx: 2.5,
    fill: "#DDE2F0"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 181,
    y: 177.4,
    width: 90,
    height: 5,
    rx: 2.5,
    fill: "#DDE2F0"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 181,
    y: 171.4,
    width: 130,
    height: 34,
    rx: 7,
    fill: "#F5F7FD"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M 191 193.4 q 6 -16 12 -4 q 4 10 10 -2 q 5 -10 10 2 q 3 8 9 -3",
    fill: "none",
    stroke: "#20305B",
    strokeWidth: 2.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 189,
    y1: 199.4,
    x2: 253,
    y2: 199.4,
    stroke: "#C3CADE",
    strokeWidth: 1.6
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#soft2)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 325.08,
    y1: 136.41,
    x2: 331.84,
    y2: 134.6,
    stroke: "#FBB024",
    strokeWidth: 2.6,
    strokeLinecap: "round",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 322.38,
    y1: 156.9,
    x2: 328.44,
    y2: 160.4,
    stroke: "#FBB024",
    strokeWidth: 2.6,
    strokeLinecap: "round",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 305.99,
    y1: 169.48,
    x2: 307.8,
    y2: 176.24,
    stroke: "#FBB024",
    strokeWidth: 2.6,
    strokeLinecap: "round",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 285.5,
    y1: 166.78,
    x2: 282,
    y2: 172.84,
    stroke: "#FBB024",
    strokeWidth: 2.6,
    strokeLinecap: "round",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 272.92,
    y1: 150.39,
    x2: 266.16,
    y2: 152.2,
    stroke: "#FBB024",
    strokeWidth: 2.6,
    strokeLinecap: "round",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 275.62,
    y1: 129.9,
    x2: 269.56,
    y2: 126.4,
    stroke: "#FBB024",
    strokeWidth: 2.6,
    strokeLinecap: "round",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 292.01,
    y1: 117.32,
    x2: 290.2,
    y2: 110.56,
    stroke: "#FBB024",
    strokeWidth: 2.6,
    strokeLinecap: "round",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 312.5,
    y1: 120.02,
    x2: 316,
    y2: 113.96,
    stroke: "#FBB024",
    strokeWidth: 2.6,
    strokeLinecap: "round",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 292 147.4 L 284 173.4 L 295 167.4 L 301 177.4 L 301 147.4 Z",
    fill: "url(#ribbon)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 306 147.4 L 314 173.4 L 303 167.4 L 297 177.4 L 297 147.4 Z",
    fill: "#C66F09"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.64 143.40 L319.28 148.84 L314.28 152.22 L313.85 158.25 L307.82 158.68 L304.44 163.68 L299.00 161.04 L293.56 163.68 L290.18 158.68 L284.15 158.25 L283.72 152.22 L278.72 148.84 L281.36 143.40 L278.72 137.96 L283.72 134.58 L284.15 128.55 L290.18 128.12 L293.56 123.12 L299.00 125.76 L304.44 123.12 L307.82 128.12 L313.85 128.55 L314.28 134.58 L319.28 137.96 Z",
    fill: "url(#gold)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 299,
    cy: 143.4,
    r: 13.860000000000001,
    fill: "#FBB024",
    stroke: "#FFC658",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 292.7 143.4 l 4.2 4.62 l 8.4 -9.24",
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M 84 204 L 104 204 L 90 222 Z",
    fill: "#FFFFFF"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#soft2)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 150,
    width: 92,
    height: 58,
    rx: 9,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 84,
    cy: 170,
    r: 9,
    fill: "#43979B"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98,
    y: 163,
    width: 46,
    height: 6,
    rx: 3,
    fill: "#C3CADE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98,
    y: 174,
    width: 34,
    height: 6,
    rx: 3,
    fill: "#E0E4F0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 188,
    width: 64,
    height: 7,
    rx: 3.5,
    fill: "#E2ECFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 188,
    width: 30,
    height: 7,
    rx: 3.5,
    fill: "#6E93F4"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 152,
    cy: 158,
    r: 7,
    fill: "#F8694A",
    stroke: "#FFFFFF",
    strokeWidth: 2
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#soft2)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 330,
    y: 196,
    width: 96,
    height: 74,
    rx: 9,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 346,
    cy: 214,
    r: 7,
    fill: "#4BB970",
    stroke: "#4BB970",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 342.5 214 l 2.5 2.6 l 4.5 -5",
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 360,
    y: 210,
    width: 52,
    height: 6,
    rx: 3,
    fill: "#C3CADE"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 346,
    cy: 234,
    r: 7,
    fill: "#4BB970",
    stroke: "#4BB970",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 342.5 234 l 2.5 2.6 l 4.5 -5",
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 360,
    y: 230,
    width: 52,
    height: 6,
    rx: 3,
    fill: "#C3CADE"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 346,
    cy: 254,
    r: 7,
    fill: "#FFFFFF",
    stroke: "#C3CADE",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 360,
    y: 250,
    width: 40,
    height: 6,
    rx: 3,
    fill: "#E0E4F0"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M 150 190 Q 175 176 198 178",
    fill: "none",
    stroke: "#8FABF3",
    strokeWidth: 2,
    strokeDasharray: "1 6",
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M 300 214 Q 330 214 348 210",
    fill: "none",
    stroke: "#8FABF3",
    strokeWidth: 2,
    strokeDasharray: "1 6",
    strokeLinecap: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgContractExchange);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/contract_exchange.24b694305833f101147892233881be5a.svg";